import type { Answer } from './GameCollectionShelfPhoto'
import { NoImageIcon } from '../icons/NoImageIcon'
import { ThemeButton } from '../ThemeButton'

type Props = {
  answer: Answer | null
  onClick: (answerId: string) => void
}

export function GameCollectionImageModal(props: Props) {
  const { answer, onClick } = props

  return (
    <div className="flex flex-col items-center gap-4 pt-4">
      {answer && (
        <>
          {answer.imageUrl ? <img src={answer.imageUrl} alt="answer image" className="max-h-[372px] grow" /> : <NoImageIcon width={279} height={279} />}
          <ThemeButton className="flex-[0_0_42px] font-bold" onClick={() => onClick(answer.answerId)}>記録を見る</ThemeButton>
        </>
      )}
    </div>
  )
}
